(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-dino"]) return;
  try {
    
gsap.registerPlugin(ScrollTrigger);
const searchContainer = document.querySelector('.dino-search_container')
const headerOffset = document.querySelector('.section-announcement-bar-dino').offsetHeight;
const searchScrollTrigger = ScrollTrigger.create({
  scroller: searchContainer,
  trigger: document.querySelector('.dino-search_wrap'),
  start: `${headerOffset} top`, 
  end: '+=' + searchContainer.scrollHeight - searchContainer.clientHeight, 
  onEnter: () => {
    if (document.body.classList.contains('dino_search')) {document.body.classList.add('header--sticky');};
  },
  onLeaveBack: () => {
    if (document.body.classList.contains('dino_search')) document.body.classList.remove('header--sticky', 'header--sticky--show');
  },
  onUpdate: (self) => {
    if (document.body.classList.contains('header--sticky')) {
      if (document.body.classList.contains('dino_search')) document.body.classList.toggle('header--sticky--show', self.direction === -1)
    }
  },
  enabled: false,
});
searchScrollTrigger.disable();
const bodyScrollTrigger = ScrollTrigger.create({
  trigger: document.querySelector('.dino-header-wrapper'),
  start: 'top top', 
  end: 'max',
  onEnter: () => {
    document.body.classList.add('header--sticky', 'header--pre-sticky');
  },
  onLeaveBack: () => {
    document.body.classList.remove('header--sticky', 'header--sticky--show', 'header--pre-sticky');
  },
  onUpdate: (self) => {
    if (document.body.classList.contains('header--sticky') && (window.matchMedia("(max-width: 767px)").matches || !document.body.classList.contains('dino_search'))) {
      document.body.classList.toggle('header--sticky--show', self.direction === -1)
    }
  }
});
if(window.matchMedia("(min-width: 768px)").matches)
     searchScrollTrigger.enable();
  else searchScrollTrigger.disable();
window.addEventListener('resize', function(event){
  if (document.body.classList.contains('dino_search'))
  if(window.matchMedia("(min-width: 768px)").matches)
     searchScrollTrigger.enable();
  else searchScrollTrigger.disable();
});
  let hadSticky
  $('.dino-search-field').focus(function(){
    $('.dino-search_container').scrollTop(0);
    $("body").addClass('dino_search');
    hadSticky = document.body.classList.contains('header--sticky');
    document.body.classList.remove('header--sticky', 'header--sticky--show')
    searchScrollTrigger.refresh();
    // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'popup-scrollbar-measure';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    if (scrollbarWidth > 0) {
      $('body').css('padding-right', scrollbarWidth + 'px');
    }
  });
  let abortController;
  function fetchDionSearch(value){
    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();
    const signal = abortController.signal;
    $('.dino-search_content').addClass('ajax-loading');
    fetch(theme.routes.search_url+'?q='+value+'&type=product', {signal}).
      then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      }).
      then((response) => {
        const $parsed = $(`<div>${response}</div>`);

        $('.dino-search_content').html($parsed.find('[data-ajax-container="products"]').html());
        $('.dino-search_content').removeClass('ajax-loading');
        searchScrollTrigger.refresh();
        theme.initAnimateOnScroll();
        $('.dino-search_content product-block').each(function(i){
          gsap.fromTo(this, {y: 200, opacity: 0}, {y: 0, opacity: 1, duration: 0.7, delay: 0.2*(i%(window.matchMedia("(max-width: 767px)").matches?2:4)),scrollTrigger: {
            trigger: this,
            scroller: (window.matchMedia("(min-width: 768px)").matches)? '.dino-search_container' : '',
          }})
        })
      });
  }
  $('.dino-search-form').submit(function(e){
    e.preventDefault();
    fetchDionSearch($(this).find('.dino-search-field').eq(0).val());
  })
  $('.dino-search-field').keyup(function(e){
    if (e.key !== 'Enter') {
        fetchDionSearch($(this).val());
    }
  });
  const initSearch = $('.dino-search-field').val()
  if (window.matchMedia("(max-width: 767px)").matches){
    const initSearch = $('.dino-mobile-search-row .dino-search-field').val()
  }
  fetch(theme.routes.search_url+'?q='+initSearch+'&type=product').
    then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    }).
    then((response) => {
      const $parsed = $(`<div>${response}</div>`);
      $('.dino-search_content').html($parsed.find('[data-ajax-container="products"]').html());
      searchScrollTrigger.refresh();
      theme.initAnimateOnScroll();
    });
  $('.dino-search_close').click(function(e){
    e.preventDefault();
    document.body.classList.remove('header--sticky');
    if(hadSticky){ document.body.classList.add('header--sticky', 'header--sticky--show')}
    $("body").removeClass('dino_search');
    $('body').css('padding-right', '0px');
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function loadFromUrl (section, url, pushState) {
    if (pushState) {
      // update url history
      var fullUrl = url;
      if (fullUrl.slice(0, 1) === '/') {
        fullUrl = window.location.protocol + '//' + window.location.host + fullUrl;
      }
      window.history.pushState({ path: fullUrl }, '', fullUrl);
    }

    // limit render to section, if possible (added after pushState)
    if (section.dataset.filterSectionId) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + `section_id=${section.dataset.filterSectionId}`;
    }

    // start fetching URL
    var refreshContainerSelector = '[data-ajax-container]',
      $ajaxContainers = $(section).find(refreshContainerSelector);

    // loading state
    $ajaxContainers.addClass('ajax-loading');

    // fetch content
    if (this.currentAjaxLoadUrlFetch) {
      this.currentAjaxLoadUrlFetch.abort();
    }
    this.currentAjaxLoadUrlFetch = $.get(url, function (data) {
      this.currentAjaxLoadUrlFetch = null;

      // save active element
      if (document.activeElement) {
        this.activeElementId = document.activeElement.id;
      }

      // replace contents
      var $newAjaxContainers = $(`<div>${data}</div>`).find(refreshContainerSelector);
      $newAjaxContainers.each(function () {
        $ajaxContainers.filter(`[data-ajax-container="${this.dataset.ajaxContainer}"]`).html($(this).html());
      });

      // init theme components
      const $componentHaver = $(section);
      if ($componentHaver.length) {
        const components = $componentHaver.data('components').split(',');
        components.forEach(function (component) {
          $(document).trigger('cc:component:load', [component, $componentHaver[0]]);
        }.bind(this));
      }

      // remove loading state
      $ajaxContainers.removeClass('ajax-loading');

      // init scroll animations
      theme.initAnimateOnScroll();

      // restore active element
      if (this.activeElementId) {
        var el = document.getElementById(this.activeElementId);
        if (el) {
          el.focus();
        }
      }
      gsap.registerPlugin(ScrollTrigger)
      $('.product-list').each(function(){
        $('product-block').each(function(i){
          gsap.fromTo(this, {y: 100, opacity: 0}, {y: 0, opacity: 1, duration: 0.3, delay: 0.1*(i%(window.matchMedia("(max-width: 767px)").matches?2:4)),scrollTrigger: this});
        })
      })

      // scroll viewport (must be done after any page size changes)
      let scrollTo = section.querySelector('[data-ajax-scroll-to]');
      if (scrollTo) {
        theme.scrollToRevealElement(scrollTo);
      }
      
      $('.dino-collection_subcat').click(function(e){
         e.preventDefault();
        loadFromUrl(this.closest('[data-filter-section-id]'), this.href, true);
       });
    }.bind(this));
  }
   $('.dino-collection_cat').click(function(e){
     e.preventDefault();
     if($(this).hasClass('active')) return;
     $('.dino-collection_cat.active').removeClass('active');
     $(this).addClass('active')
      loadFromUrl(this.closest('[data-filter-section-id]'), this.href, true);
   });
    $('.dino-collection_subcat').click(function(e){
       e.preventDefault();
       if($(this).hasClass('active')) return;
        loadFromUrl(this.closest('[data-filter-section-id]'), this.href, true);
     });
  //document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    $('.product-list').each(function(){
      $('product-block').each(function(i){
        gsap.fromTo(this, {y: 200, opacity: 0}, {y: 0, opacity: 1, duration: 0.7, delay: 0.2*(i%(window.matchMedia("(max-width: 767px)").matches?2:4)),scrollTrigger: this})
      })
    })
 //});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
